import { combineReducers } from '@reduxjs/toolkit';

import { initialState as initialOffersState, offersSlice } from './offers/offers.slice';

export const initialLoyaltyState = {
  offers: initialOffersState,
};

export const loyaltyReducer = combineReducers({
  offers: offersSlice.reducer,
});
